<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/s1M9Xp/tc-custom/9781250101396.jpg?1731160443054" alt="This image is the cover for the book Shadow's Bliss, The Tales of the Jewelled Men"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shadow's Bliss, The Tales of the Jewelled Men
      </h1>
      <p class="bookDescription body article font2">
        <p><i>She had dreamed of that magical experience called falling in love.  And, dreaming, she had conjured up a dashing and handsome gentleman...A far cry from Crazy Jack, a penniless and nameless vagrant, haunted by disgrace and the shadow of some terrible tragedy. </i><br/><br/>Dreams are all that the graceful Jennifer Britewell has had of love and marriage since a childhood accident left her barren.  Now, try as she might, the generous lady cannot bring herself to believe the town gossip about "Crazy Jack."  It would be beneath her to consider him anything but a servant.  But when he allows her to see traces of his honesty, intelligence, and gallantry, all warnings of her possible disgrace fade into the mists of Cornwall...</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia Veryan
      </h2>
      
      <p class="authorDescription body article"><B>Patricia Veryan</B> was born in England and moved to the United States following World War II.  The author of several critically acclaimed Georgian and Regency series, including the Sanguinet Saga, she now lives in Kirkland, Washington.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?467116cc